import Chip from '@mui/material/Chip';
import Fade from '@mui/material/Fade';

type FadeInChipProps = {
  tagName: string;
  selectedTags: string[];
  handleTagUpdate: (name: string) => void;
  variant: 'search' | 'select';
};

export const FadeInChip = ({
  tagName,
  selectedTags,
  handleTagUpdate,
  variant,
}: FadeInChipProps) => {
  return (
    <>
      {variant === 'search' ? (
        <Fade in={true}>
          <Chip
            label={tagName}
            sx={{ ml: 1, mb: 1 }}
            size="small"
            onDelete={() => handleTagUpdate(tagName)}
          />
        </Fade>
      ) : (
        <Fade in={true}>
          <Chip
            label={tagName}
            onClick={() => handleTagUpdate(tagName)}
            variant={selectedTags.includes(tagName) ? 'filled' : 'outlined'}
            sx={{ mr: 1, mb: 1, color: '#fff' }}
          />
        </Fade>
      )}
    </>
  );
};
